import { all, call, select } from 'typed-redux-saga';

import { selectIsMeetingRoomIntegration } from '../../../shared/features/config/selectors';
import { isInsideIframe } from '../../../shared/helpers/iframe';
import { handleConferenceStatus } from './handle-conference-status';
import { handleConnection } from './handle-connection';
import { handleUiStateSync } from './handle-ui-state-sync';
import { handleErrors } from './handleErrors';
import { handleMeetingRoomMessage } from './handleMeetingRoomMessage';
import { handleMessage } from './handleMessage';
import { syncMediaDevices } from './syncMediaDevices';
import { watchMessages } from './watchMessages';

/**
 * Рутовая сага звонков в режиме iframe
 */
export function* rootIframeSaga(): Generator {
    if (NODE || !isInsideIframe()) {
        return;
    }

    const isMeetingRoomIntegration = yield* select(selectIsMeetingRoomIntegration);

    yield* all([
        call(watchMessages, isMeetingRoomIntegration ? handleMeetingRoomMessage : handleMessage),
        call(handleErrors),
        call(handleConnection),
        call(syncMediaDevices),
        call(handleUiStateSync),
        call(handleConferenceStatus),
    ]);
}
